import { HttpParams } from '@angular/common/http';

export interface RequestMetadata {
  extraUrl?: string | null;
  sufixUrl?: string | null;
  paramns?: HttpParams | null;
  objEnvio?: ObjEnvio | string | null | object | boolean;
  maxRetryAttempts?: number | null;
  timeout?: number;
}

export interface ObjEnvio {
  id: string | number | null | undefined;
}

export enum DEFAULT_TIMEOUT {
  LOW =  5000,
  MIDDLE = 10000,
  HIGH = 30000
}

